import { render, staticRenderFns } from "./ConsultationForm.vue?vue&type=template&id=8a885e00&scoped=true&"
import script from "./ConsultationForm.vue?vue&type=script&lang=ts&"
export * from "./ConsultationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultationForm.vue?vue&type=style&index=0&id=8a885e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a885e00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
